import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faCode} from '@fortawesome/pro-solid-svg-icons';
import {canCreateEmbedLinkFromAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionShareEmbedLinkIcon = faCode;

/**
 * Asset share embed link
 * @param params
 * @returns Action
 */
export const assetActionShareEmbedLink = (
	asset?: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-share-embed-link',
	cb: () => dispatcher.trigger(ASSET_EVENT.SHARE_EMBED_LINK, asset),
	enableTest: () => canCreateEmbedLinkFromAsset(asset),
	icon: assetActionShareEmbedLinkIcon,
	get label() {
		return AssetActionLabel.SHARE_EMBED_LINK;
	},
	...params,
});

export default assetActionShareEmbedLink;
